// extracted by mini-css-extract-plugin
export default {"iconTextContainer":"CreateStackButtonCard_iconTextContainer__-g7Fk","stackIcon":"CreateStackButtonCard_stackIcon__DKNpP"};